import {StyledProps, React, withStyles, observer} from '@api'
import {Tooltip2} from '@api'

import {TableCell, TableHead, TableSortLabel, TableRow, Tooltip} from '@material-ui/core'

import {useStores} from '@modules/VipLocalStore'

const styles = theme => ({
  tableHeadRoot: {
    fontSize: '12px',
    padding: '4px 24px',
    fontWeight: 'normal'
  },
  tableHeadImageRoot: {
    fontSize: '12px',
    padding: '4px 24px',
    fontWeight: 'normal'
  },
  tableRow: {
    height: '48px'
  },
  columnTitleNoSort: {
    userSelect: 'none'
  },
  sortIcon: {
    color: 'var(--icon-grey-1)'
  }
})

export interface TableColumnDefinition {
  showHexImage?: boolean,
  showImage?: boolean,
  disablePadding?: boolean,
  id?: string,
  disableSort?: boolean,
  label?: string
  isActions?: boolean
  colSpan?: number
}

interface MyProps extends StyledProps {
  sortOrder?: 'asc' | 'desc';
  sortBy?: string,
  data: Array<TableColumnDefinition>
  onSortRequest?: (e, columnId) => void
}

export const LibraryTableHeader: any = withStyles(styles as any)(observer<MyProps>(function LibraryTableHeader(props) {
  const {sortOrder, sortBy, data, classes, onSortRequest} = props,
    {strings} = useStores()
  return (
    <TableHead>
      <TableRow classes={{root: classes.tableRow}}>
        {data.map((column, i) => {
          return (
            <TableCell
              key={column.id || i}
              classes={{root: (column.showHexImage || column.showImage) ? classes.tableHeadImageRoot : classes.tableHeadRoot}}
              padding={column.disablePadding ? 'none' : 'default'}
              sortDirection={sortBy === column.id ? sortOrder : false}
              colSpan={column.colSpan || 1}
            >
              {!column.disableSort
               ? (<Tooltip2
                  content={strings.sort}
                  placement={'bottom-start'}
                >
                  <TableSortLabel
                    active={sortBy === column.id}
                    direction={sortOrder}
                    onClick={(event) => onSortRequest(event, column.id)}
                    classes={{icon: classes.sortIcon}}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip2>)
               : <div className={classes.columnTitleNoSort}>{column.label}</div>
              }
            </TableCell>
          )
        }, this)}
      </TableRow>
    </TableHead>
  )
}))

LibraryTableHeader.defaultProps = {sortOrder: 'asc', sortBy: 'id'}


// WEBPACK FOOTER //
// ./src/modules/libraries/components/LibraryTableHeader.tsx